// extracted by mini-css-extract-plugin
export default {"Apercus":"ImporterCapteurCSV_Apercus__rYrV6","label":"ImporterCapteurCSV_label__VC7eB"};